<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm">
        </div>
        <div class="col-sm">
          <div class="card text-center">
            <div class="card-header">
              Your Number
              <p> {{ expiredTime }}</p>
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ number | Number}}</h5>
              <p class="card-text">Messages will appear bellow</p>
              <form>
                <div class="form-group">
                  <input type="text" class="form-control" id="toNumber" v-model="toNumber"  placeholder="To Number">
                </div>
                <div class="form-group">
                  <textarea class="form-control" id="message" placeholder="Your Message" v-model="message" rows="3"></textarea>

                </div>
                <a href="#"  @click="sendMessage" :disabled="!isSending"  class="btn btn-primary">{{ sendMessageText }}</a>
                <div class="alert alert-success mt-3" v-if="showAlert" role="alert">
                  Message Send!
                </div>
                <div class="alert alert-danger mt-3" v-if="showErrorAlert" role="alert">
                  {{ errorMessage }}
                </div>

              </form>
            </div>
          </div>
        </div>
        <div class="col-sm">
        </div>

      </div>
      <div class="row mt-5 mb-5">
        <div v-for="message in messages" class="col-sm" v-bind:key="message.message_id">
          <div class="card" style="max-width: 18rem; margin:auto; margin-bottom: 10px">
            <div class="card-header">{{ message.m_from | Number }}
              <i id="message_src_ic" class="material-icons" :class="message.src === 'out' ? 'red_i' : 'green_i' ">{{ message.src === 'out' ? 'call_made' : 'call_received' }}</i>
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ message.message_text }}</h5>
              <a href="#" v-if="message.src === 'in' " @click="replayToNumber(message.m_from)" class="btn btn-primary">Send Message Back</a>

            </div>
          </div>
        </div>
        <div class="col-sm">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
let baseUrl = process.env.VUE_APP_API
const jwtDecode = require('jwt-decode')

export default {
  name: 'Home',
  data () {
    return {
      number: '...',
      id: 0,
      messages: [],
      toNumber: '',
      message: '',
      isSending: false,
      sendMessageText: 'Send Message',
      showAlert: false,
      showErrorAlert: false,
      errorMessage: '',
      expiredTime: ''

    }
  },
  methods: {
    showExpired (token) {
      var decoded = jwtDecode(token)
      let expDate = new Date(decoded.exp * 1000)

      let MyDateString = ('0' + expDate.getDate()).slice(-2) + '-' +
            ('0' + (expDate.getMonth() + 1)).slice(-2) + '-' +
            expDate.getFullYear() + ' ' + ('0' + expDate.getHours()).slice(-2) + ':' + ('0' + expDate.getHours()).slice(-2)

      this.expiredTime = `Expired at: ${MyDateString}`
    },
    getMessages () {
      let data = {
        action: 'get_messages',
        number_id: this.id
      }
      let config = {
        headers: {
          post: {
            'Authorization': ''

          }
        }
      }

      this.axios.post(baseUrl + 'server/api/meser_api.php', data, config).then((response) => {
        console.log(response)
        if (this.messages.length < response.data.data.length) {
          this.$toasted.info('New Message!', {
            icon: 'message',
            duration: 5000,
            position: 'bottom-right'
          })
        }
        this.messages = response.data.data
      })
    },
    sendMessage () {
      if (this.message.length === 0) {
        this.showErrorMessage('You must enter message to send')
        return
      }
      let data = {
        action: 'send_messages',
        from_number_id: this.id,
        to_number: this.toNumber.replace(/\s+/g, '').replace(/-/g, ''),
        message: this.message
      }
      let config = {
        headers: {
          post: {
            'Authorization': ''

          }
        }
      }
      this.$ga.event({
        eventCategory: 'messages',
        eventAction: 'send',
        eventLabel: 'Message Send',
        eventValue: this.id
      })

      this.isSending = true
      this.sendMessageText = 'Sending...'
      this.axios.post(baseUrl + 'server/api/meser_api.php', data, config).then((response) => {
        console.log(response)
        this.isSending = false
        if (response.data.status === 1) {
          this.message = ''
          this.sendMessageText = 'Send Message'
          this.showAlert = true
          setTimeout(() => {
            this.showAlert = false
          }, 5000)
        } else {
          this.sendMessageText = 'Send Message'
          this.showErrorMessage(response.data.message)
        }
      })
    },
    showErrorMessage (msg) {
      this.showErrorAlert = true
      this.errorMessage = msg
      setTimeout(() => {
        this.showErrorAlert = false
      }, 5000)
    },
    replayToNumber (replayNumber) {
      this.toNumber = replayNumber
    }
  },
  created () {
    let data = {
      action: 'create_number'
    }
    let config = {
      headers: {
        post: {
          'Authorization': ''

        }
      }
    }

    console.log(this.$session.getAll())
    if (this.$session.exists()) {
      let token = this.$session.get('jwt')
      this.showExpired(token)
      config = {
        headers: {
          post: {
            'Authorization': token

          }
        }
      }
    }

    this.axios.post(baseUrl + 'server/api/meser_api.php', data, config).then((response) => {
      console.log(response)
      if (!this.$session.get('jwt')) {
        let jwt = response.data.data.jwt

        this.$session.start()
        this.$session.set('jwt', jwt)
      }

      let token = this.$session.get('jwt')
      this.showExpired(token)

      this.number = response.data.data.number.number
      this.id = response.data.data.number.id
      setInterval(this.getMessages, process.env.VUE_APP_TIMEOUT)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;  /* Preferred icon size */
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;

    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;

    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;

    /* Support for IE. */
    font-feature-settings: 'liga';
  }
  #message_src_ic{
    float:right;
  }

  .green_i{
  color:#4CAF50;
  }
  .red_i{
    color:#F44336;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue